export const QA_FAVOURITES_ONLY_KEY = 'qa-favourites-only'
export const LEGISLATION_FAVOURITES_ONLY_KEY = 'legislation-favourites-only'
export const DOCUMENT_FAVOURITES_ONLY_KEY = 'document-favourites-only'
export const DOCUMENT_AUTOMATED_ONLY_KEY = 'document-automated-only'
export const SMART_SEARCH_ENABLED = 'smart-search-enabled-v2'
